import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {accountSearchResultStateSelector} from './account-search-result-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountSearchCriteria} from 'src/openapi/admin/models/AccountSearchCriteria';
import type {AccountSearchFiltering} from 'src/openapi/admin/models/AccountSearchFiltering';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';
import type {LicenseSearchInfo} from 'src/openapi/admin/models/LicenseSearchInfo';

export const accountSearchResultLicenseSlice = getCachedTableDataSlice<
    Record<string, LicenseSearchInfo>,
    AccountSearchCriteria,
    AccountSortField,
    AccountSearchFiltering
>('accountSearchResultLicense');

export const accountSearchResultLicenseActions = accountSearchResultLicenseSlice.actions;

const accountSearchResultLicenseCacheSelector: CachedTableCacheSelector<Record<string, LicenseSearchInfo>>
    = state => state.accountSearchResult.license.cache;
export const accountSearchResultLicenseDataSelector: CachedTableDataSelector<Record<string, LicenseSearchInfo>>
    = state => state.accountSearchResult.license;
export const accountSearchResultLicenseResultSelector = getCachedTableResultSelector(
    accountSearchResultLicenseCacheSelector,
    accountSearchResultStateSelector,
);
